import { render, staticRenderFns } from "./AddProceduresModal.vue?vue&type=template&id=85833a02&lang=pug&"
import script from "./AddProceduresModal.vue?vue&type=script&lang=js&"
export * from "./AddProceduresModal.vue?vue&type=script&lang=js&"
import style0 from "./AddProceduresModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports